import * as React from 'react';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps, ThemeType } from 'theme/jss-types';
import { formFields } from 'components/create-consignment/create-modal.constants';
import { useTranslation } from 'react-i18next';
import { Col, Form } from 'antd';
import { commonStyleSheet } from 'library/common-styles';
import TextArea from 'antd/lib/input/TextArea';

const styles = (theme: ThemeType) => ({
    formItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        '& .ant-checkbox + span': {
            color: '#111111',
            fontSize: 14,
            fontWeight: 600,
        },
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
    },
    descriptionTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        marginBottom: 4,
    },
    description: {
        ...commonStyleSheet(theme).flexColumn,
    },
});

interface IProps extends StylesProps<ReturnType<typeof styles>>, ReturnType<typeof mapStateToProps> {
    params: any;
}

const DescriptionField = (props: IProps) => {
    const { t } = useTranslation();
    const { classes, params } = props;
    const { Description } = formFields;
    const {
        id: pieceIndex, getValidationRules, key, getIsRequiredValidation, disabledFields = {},
    } = params;
    const isPieceLevel = pieceIndex !== null && pieceIndex !== undefined;
    const descriptionKey = isPieceLevel ? key : Description.key;

    return (
        <Col span={24} xs={24} sm={24} md={12}>
            <div className={classes.description}>
                <div className={classes.descriptionTitle}>
                    {t(Description.key)}
                    {getIsRequiredValidation(Description.key, isPieceLevel) && '*'}
                </div>
                <Form.Item
                    name={descriptionKey}
                    initialValue={Description.defaultValue}
                    valuePropName={Description.valuePropName}
                    rules={getValidationRules(Description, isPieceLevel)}
                >
                    <TextArea
                        rows={1}
                        placeholder={t(Description.key)}
                        disabled={disabledFields[descriptionKey || '']}
                        style={{ width: Description.width }}
                    />
                </Form.Item>
            </div>
        </Col>
    );
};

const mapStateToProps = () => {
    return {};
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
};

export default GenericHoc(hocConfig)(DescriptionField);
